import Quill from 'quill';

const Embed = Quill.import('blots/embed');

const objPolyvSpeed = {
  0: 1,
  1: 1.3,
  2: 1.5,
  3: 2,
};

export class Timetag extends Embed {
  static create(objTime) {
    let node = super.create();
    const objTimeAndStr = this.getObjTimeAndStr(objTime);
    node.dataset.time = objTime.time;
    node.dataset.strTime = objTimeAndStr.strTime;
    node.dataset.speed = objTime.speed;
    node.dataset.polyvSpeed = objTimeAndStr.polyvSpeed;

    const timeTagItem = document.createElement('span');
    timeTagItem.classList.add('time-tag-item');
    timeTagItem.setAttribute('contenteditable', false);
    node.appendChild(timeTagItem);

    const icon = document.createElement('i');
    icon.classList.add('pz-icon', 'icon-activity');
    timeTagItem.appendChild(icon);

    const timeTagItemText = document.createElement('span');
    timeTagItemText.classList.add('time-tag-item__text');
    timeTagItemText.textContent = objTimeAndStr.textContent;
    timeTagItem.appendChild(timeTagItemText);
    return node;
  }

  constructor(domNode) {
    super(domNode);
    domNode.addEventListener('click', () => {
      if (window.quillTimeTagSeekVideo) {
        window.quillTimeTagSeekVideo(domNode.dataset);
      }
    });
  }

  static value(domNode) {
    return domNode.dataset;
  }

  static replaceHtmlString(str) {
    return str.replace(
      /(<span [^>]*class="ql-tag-blot".*?>)\u{FEFF}<span contenteditable=(["'])false\2>(.*?)<\/span>\u{FEFF}(<\/span>)/gsu,
      '$1$3$4'
    );
  }

  static getObjTimeAndStr(objTime) {
    const hours = objTime.time / 3600;
    const minutes = (objTime.time % 3600) / 60;
    const seconds = objTime.time % 60;
    const lstHMS = hours > 1 ? [hours, minutes, seconds] : [minutes, seconds];
    const strTime = lstHMS.map((val) => `0${Math.floor(val)}`.slice(-2)).join(':');
    const polyvSpeed = objPolyvSpeed[objTime.speed];
    return {
      time: objTime.time,
      strTime,
      speed: objTime.speed,
      polyvSpeed,
      textContent: `${strTime} (${polyvSpeed}X)`,
    };
  }
}
Timetag.blotName = 'timetag';
Timetag.tagName = 'span';
Timetag.className = 'ql-tag-blot';

export default Timetag;
